import { GlobalsService } from './globals.service';
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { PartSuppliers } from '../classes/PartSuppliers';
import { FileInfo } from '@progress/kendo-angular-upload';
import { InventoryPhotoBus } from '../models/InventoryPhotoBus';
import { CommonParam } from '../models/CommonParam';
import { BaseMessageInfo } from '../models/BaseMessageInfo';
import { HotKeyRequest } from '../models/HotKeyRequest';
import { CycleCount, CycleCountInventory, CycleCountInventoryInput, CycleCountdetails } from '../models/CycleCount';
import { InventoryTypeBus } from '../models/InventoryTypeBus';
import { InventoryCategoryBus } from '../models/InventoryCategoryBus';
import { InventorySubcategoryBus } from '../models/InventorySubcategoryBus';
import { environment } from '@env/environment';
import { InventoryThresholdOverrideAlternative } from '../models/InventoryThresholdOverrideAlternative';
import { AttachmentBus } from '../models/AttachmentBus';

@Injectable()
export class InventoryService extends BaseService {

    APIEndPoint_v2 = environment.APIEndPoint_v2
    partSuppliers: PartSuppliers = new PartSuppliers(this);
    cycleCountShowOnlyActive: boolean = false;
    cycleCountShowOnlyMine: boolean = false;
    cycleCountBranchCode: string = "";
    constructor(_http: HttpClient, private globalsService: GlobalsService) {
        super(_http);
        this.baseUrl = this.rootUrl + "Inventory/";
        this.baseUrl_v2 = this.baseUrl_v2 + "Inventory/"
        //  this.partSuppliers = new PartSuppliers(this);
    }

    get(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "Get/" + id;
        return super.get(url_call); // this._http.get(url_call); //, { headers: headers }); //, { headers: headers });
    }
    getOnly(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOnly/" + id;
        return super.get(url_call); // this._http.get(url_call); //, { headers: headers }); //, { headers: headers });
    }
    getAlternatives() {}
    getAdditionalPartsData(id: string) {
        let url_call: string = this.baseUrl + "GetAdditionalPartsData/" + id;
        return super.get(url_call); // this._http.get(url_call); //, { headers: headers }); //, { headers: headers });
    }
    getPhotoUrl(): string {
        let url_call: string = this.baseUrl + "GetInventoryPhoto/"
        return url_call; // this._http.get(url_call); //, { headers: headers }); //, { headers: headers });
    }
    downloadExcel(call: string) {
        let url_call: string = this.baseUrl + "Get/" + call;
        let headers = this.getHeaders();
        
        return this._http.get(url_call,  {
            headers: headers,responseType: 'blob' // Essential for binary data  });
        });
     }
    getViewById(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetViewById/" + id;
        return super.get(url_call); // this._http.get(url_call); //, { headers: headers }); //, { headers: headers });
    }

    
    ImportBranchThreshold(files: FileInfo[], data: AttachmentBus): Observable<any> {
        let url: string = this.baseUrl + "ImportBranchThreshold";
        let dataStr: string = JSON.stringify(data);
        // Init formData
        data.attachment = null;
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }
        formData.append("AttachmentData", dataStr);
        return this._http.put(url, formData);
    }

    importThreshold(files: FileInfo[], data: AttachmentBus): Observable<any> {
        let url: string = this.baseUrl + "ImportThreshold";
        let dataStr: string = JSON.stringify(data);
        // Init formData
        data.attachment = null;
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }
        formData.append("AttachmentData", dataStr);
        return this._http.put(url, formData);
    }
    importPart(files: FileInfo[], data: AttachmentBus): Observable<any> {
        let url: string = this.baseUrl + "ImportPart";
        let dataStr: string = JSON.stringify(data);
        // Init formData
        data.attachment = null;
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }
        formData.append("AttachmentData", dataStr);
        return this._http.put(url, formData);
    }
    quickSearch(search: string): Observable<any> {
        let url_call: string = this.baseUrl + "QuickSearch/" + search;
        return super.get(url_call); // this._http.get(url_call); //, { headers: headers }); //, { headers: headers });
    }
    getAll(isActive: boolean): Observable<any> {
        let url_call: string = this.baseUrl + "GetAll/" + (isActive === true ? 'true' : 'false');
        return super.get(url_call);
    }
    getForList(isActive: boolean): Observable<any> {
        let url_call: string = this.baseUrl + "getForList/" + isActive ? 'true' : 'false';
        return super.get(url_call);
    }
    getInventorySuppliers(inventoryId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetInventorySuppliers/" + inventoryId;
        return super.get(url_call);
    }
    getCPInventoryLocationXref(inventoryId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetCPInventoryLocationXref/" + inventoryId;
        return super.get(url_call);
    }
    getLocationQuantity(inventoryId: string, inventoryLocationId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetLocationQuantity/" + inventoryId + "/" + inventoryLocationId;
        return super.get(url_call);
    }
    getLocationQuantityAndAll(inventoryId: string, inventoryLocationId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetLocationQuantityAndAll/" + inventoryId + "/" + inventoryLocationId;
        return super.get(url_call);
    }
    getLocationQuantityDetail(inventoryId: string, inventoryLocationId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetLocationQuantityDetail/" + inventoryId + "/" + inventoryLocationId;
        return super.get(url_call);
    }

    getLocationQuantitys(inventoryId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetLocationQuantitys/" + inventoryId;
        return super.get(url_call);
    }
    getSupplierAddress(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetSupplierAddress/" + id;
        return super.get(url_call);
    }
    getSupplierLocationAddress(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetSupplierLocationAddress/" + id;
        return super.get(url_call);
    }

    getReferenceData(): Observable<any> {
        let url_call: string = this.baseUrl + "GetReferenceData";
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        return this._http.get(url_call, options);;
    }

    getManufacturerTypes(): Observable<any[]> {
        let url_call = this.APIEndPoint_v2 + "Inventory/manufacturerType";
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        return this._http.get(url_call, options);;
    }

    saveManufacturerType(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call = this.APIEndPoint_v2 + "Inventory/manufacturerType";
        return this._http.post(url_call, model, { headers });
    }

    getContractPrices(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "GetContractPrices";
        return this._http.put(url_call, model, { headers });
    }
    save(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "Save";
        return this._http.put(url_call, model, { headers });
    }
    saveStockReplenishment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveStockReplenishment";
        return this._http.put(url_call, model, { headers });
    }
    saveInventoryTransfer(model: any): Observable<BaseMessageInfo> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveInventoryTransfer";
        return this._http.put(url_call, model, { headers });
    }
    saveInventoryTransferAll(model: any): Observable<BaseMessageInfo> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveInventoryTransferAll";
        return this._http.put(url_call, model, { headers });
    }
    getInventoryXferHistory(inventoryLocationId: string, inventoryId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetInventoryXferHistory/" + inventoryLocationId + "/" + inventoryId;
        return super.get(url_call);
    }

    deleteInventoryPhotos(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "DeleteInventoryPhotos/" + id;
        return super.get(url_call);
    }

    getItemSelected(param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "GetItemSelected";
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    getStockReplenishments(): Observable<BaseMessageInfo> {

        var param = new CommonParam();
        param.dcParams = new Object();
        let url_call: string = this.baseUrl + "GetStockReplenishments";
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    getWarehousePartsByWareHouse(inventoryLocationId: string): Observable<BaseMessageInfo> {

        var param = new CommonParam();
        param.dcParams = new Object();
        param.dcParams["InventoryLocationId"] = inventoryLocationId;
        let url_call: string = this.baseUrl + "GetWarehousePartsByWareHouse";
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    getInventoryLocationsForInventoryItem(inventoryId: any): Observable<any> {
        let url_call: string = this.baseUrl + "GetInventoryLocationsForInventoryItem/" + inventoryId;
        return super.get(url_call);
    }
    getLabelPrintQueueReferenceData(): Observable<any> {
        let url_call: string = this.baseUrl + "GetLabelPrintQueueReferenceData";
        return super.get(url_call);
    }
    saveLabelPrintQueueItem(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveLabelPrintQueueItem";
        return this._http.put(url_call, model, { headers });
    }
    saveInventoryTransferHistory(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveInventoryTransferHistory";
        return this._http.put(url_call, model, { headers });
    }
    inventoryCostHistoryException_Acknowledge(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "InventoryCostHistoryException_Acknowledge";
        return this._http.put(url_call, model, { headers });
    }
    getInventoryCostExceptionPct(): Observable<any> {
        let url_call: string = this.baseUrl + "GetInventoryCostExceptionPct";
        return super.get(url_call);
    }
    saveInventoryCostExceptionPct(value: any): Observable<any> {
        let url_call: string = this.baseUrl + "SaveInventoryCostExceptionPct/" + value;
        return super.get(url_call);
    }

    inventoryCostAdjustment_Save(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "InventoryCostAdjustment_Save";
        return this._http.put(url_call, model, { headers });
    }
    inventoryCostAdjustment_Delete(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "InventoryCostAdjustment_Delete/" + id;
        return super.get(url_call);
    }

    uploadInventoryPhoto(files: FileInfo[], attachmentName: string, inventoryPhoto: InventoryPhotoBus): Observable<any> {
        const url: string = this.baseUrl + "UploadInventoryPhoto";
        const formData = new FormData();

        // Append files to formData with consistent 'files' key for each file
        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }

        // Create attachment data object and stringify it for a single append
        const attachmentData = {
            attachmentName: attachmentName,
            inventoryId: inventoryPhoto.inventoryId,
            inventoryPhotoCategoryId: inventoryPhoto.inventoryPhotoCategoryId,
            imageName: inventoryPhoto.imageName,
            fileName: inventoryPhoto.fileName,
            description: inventoryPhoto.description,
            visibleToCustomers: inventoryPhoto.visibleToCustomers,
            sequenceNumber: inventoryPhoto.sequenceNumber || ''
        };

        formData.append("AttachmentData", JSON.stringify(attachmentData));

        return this._http.put(url, formData);
    }
    getInventoryBC(param: HotKeyRequest): Observable<any> {
        let url_call: string = this.baseUrl + "GetInventoryBC";
        let s_param = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "hotKeyRequest", s_param);
        return this._http.get(url_call, options);
    }
    /*********************************************************************************
     * doInventoryCostCalculation (API) & inventoryCostCalculate (SQL) do same thing
     * primary is inventoryCostCalculate - (SQL)
     * *******************************************************************************/
    doInventoryCostCalculation(param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "DoInventoryCostCalculation";
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    inventoryCostCalculate(param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "InventoryCostCalculate";
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    getPartsCost(param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "GetPartsCost";
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    getInventoryCostDetail(param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "GetInventoryCostDetail";
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }

    getInventoryTypes(): Observable<any> {
        let url_call: string = this.rootUrl_v2 + "Inventory/types";
        return super.get(url_call);
    }

    getInventoryCategories(): Observable<any> {
        let url_call: string = this.rootUrl_v2 + "Inventory/categories";
        return super.get(url_call);
    }

    getInventorySubcategories(): Observable<any> {
        let url_call: string = this.rootUrl_v2 + "Inventory/subcategories";
        return super.get(url_call);
    }

    saveInventoryAlternatives(busObj: InventoryThresholdOverrideAlternative[]): Observable<any> {
        let url_call: string = this.rootUrl_v2 + "Inventory/alternatives";
        let headers = this.getHeaders();
        return super.post(url_call, busObj);
    }

    saveInventoryType(busObj: InventoryTypeBus): Observable<any> {
        let url_call: string = this.rootUrl_v2 + "Inventory/type";
        let headers = this.getHeaders();
        return super.post(url_call, busObj);
    }

    saveInventoryCategory(busObj: InventoryCategoryBus): Observable<any> {
        let url_call: string = this.rootUrl_v2 + "Inventory/category";
        let headers = this.getHeaders();
        return super.post(url_call, busObj);
    }

    saveInventorySubcategory(busObj: InventorySubcategoryBus): Observable<any> {
        let url_call: string = this.rootUrl_v2 + "Inventory/subcategory";
        let headers = this.getHeaders();
        return super.post(url_call, busObj);
    }

    /*********************************************************************************
     * cycle counting
     * *******************************************************************************/

    /**
     * get saved cycle count list data
     * @param {string} searchText : selected cycle count id
     * @return {CycleCountdetails[]}
     * @private
     */
    getCycleCountingData(searchText: string, activeOnly: number = 0): Observable<any> {
        let url_call: string = this.baseUrl + "GetCycleCounts/" + searchText + "/" + activeOnly.toString();

        return super.get(url_call);
    }

    /**
     * get dropdaown data for new cycle count
     * @return {cycleCountDataReference}
     * @private
     */
    getCycleCountDataReference(): Observable<any> {
        let url_call: string = this.baseUrl + "GetCycleCountDataReference";
        return super.get(url_call);
    }

    /**
     * delete cycle count delete
     * @param {string} id: selected cycle count ID
     * @return {BaseMessageInfo}
     * @private
     */
    cycleCountDelete(id: string): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "CycleCountDelete/" + id;
        return this._http.delete(url_call, { headers });
    }

    /**
     * cancel cycle count delete
     * @param {string} id: selected cycle count ID
     * @return {BaseMessageInfo}
     * @private
     */
    cancelCount(id: string): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "CycleCountCancel/" + id;
        return this._http.get(url_call, { headers });
    }

    /**
     * commit cycle count delete
     * @param {string} id: selected cycle count ID
     * @return {BaseMessageInfo}
     * @private
     */
    cycleCountCommit(id: string): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "CycleCountCommit/" + id;
        return this._http.get(url_call, { headers });
    }

    /**
     * get inventory parts list from saved cycle count
     * @param {CycleCountInventoryInput} model : selected cycle count inventoryLocationId,inventoryLocationId,inventorySubCategoryId
     * @return {CycleCountInventory}
     * @private
     */
    getCycleCountInventories(model: CycleCountInventoryInput): Observable<CycleCountInventory[]> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "GetCycleCountInventories";
        return this._http.post(url_call, model, { headers });
    }

    /**
     * get inventory parts list from saved cycle count
     * @param {CycleCountdetails} model
     * @return {BaseMessageInfo}
     * @private
     */
    saveCycleCount(model: CycleCountdetails): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveCycleCount";
        return this._http.put(url_call, model, { headers });
    }

    saveCycleCountVarianceNote(inventoryId: string, cycleCountsId: string, note: string): Observable<BaseMessageInfo> {
        const headers = this.getHeaders();
        const url = `${this.baseUrl}${inventoryId}/cycle_count/${cycleCountsId}`;
        return this._http.post(url, JSON.stringify(note), { headers: headers }) as Observable<BaseMessageInfo>;
    }

    updateInventoryCount(model: CycleCountInventory): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "UpdateInventoryCount";
        return this._http.put(url_call, model, { headers });
    }

    getBranches() {
        let url_call: string = this.baseUrl + "GetBranches";
        return super.get(url_call);
    }
}
